import LayoutLoading from '@/components/layout/layout-loading';

const LoadingScreen: React.FC = () => {
  return <LayoutLoading />;
};

export default LoadingScreen;
